import { get } from '@helpcenter/ajax';
import * as qs from 'query-string';
import { Observable } from 'rxjs/Observable';
import { trackError } from '@atlassian/help-center-common-util/analytics';
import { contextPath } from '@atlassian/help-center-common-util/history';
import type { AssetFieldConfig, AssetOrigin, AssetPage } from 'view/common/fields/assets-picker/types';

export const searchAssets = (
    assignee: string,
    query: string,
    fieldConfig: AssetFieldConfig,
    context: string = contextPath
): Observable<AssetPage> => {
    const assignees = [assignee];
    assignees.push('unassigned');
    const queryString: string = qs.stringify({
        query,
        // get assets assigned to user and all other unassigned assets
        assignee: assignees,
        prioritizedAssignee: assignee,
        type: fieldConfig?.types?.map((type: AssetOrigin) => {
            // type to serialized type origin
            return `${type.appKey}/${type.originId}`.toLowerCase();
        }),
    });
    const uri = `${context}/rest/assetapi/asset/search?${queryString}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
        get(uri)
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .map(({ response }) => response)
            .catch((e) => {
                trackError('search.assets.failed', {}, e);
                // Rethrow error
                return Observable.throw(e);
            })
    );
};

export const getFieldConfig = (fieldConfigId: string, portalId: number): Observable<AssetFieldConfig> => {
    const uri = `${contextPath}/rest/assetinternalapi/1/field/portal/${portalId}/config/${fieldConfigId}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
        get(uri)
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .map(({ response }) => response)
            .catch((e) => {
                trackError('assets.get.field.config.id.failed', {}, e);
                // Rethrow error
                return Observable.throw(e);
            })
    );
};
